import { IApplicationState } from '../../types/redux';
import { ISelected } from '../../reducers/selected';
import { getKey } from '../../utils/selected';
import { createSelector } from 'reselect';

export const selectAllEntities = createSelector(
  (state: IApplicationState) => state.results.favoriteEntities,
  items => {
    const entities = {} as ISelected;
    items.forEach(entity => {
      const { entityId, entityType, fullUrl } = entity;
      const key = getKey(entityId, entityType);
      entities[key] = {
        entityId,
        entityType,
        fullUrl,
      };
    });

    return entities;
  },
);
